<h1 mat-dialog-title>Datei hochladen</h1>
<div mat-dialog-content>
  <form [formGroup]="uploadForm">
    <!-- Normales Datei-Eingabefeld, ohne mat-form-field -->
    <label>Datei auswählen:</label>
    <input type="file" accept="image/*,application/pdf" (change)="onFileSelected($event)" capture="environment" />

    <!-- Fortschrittsbalken -->
    <mat-progress-bar
      *ngIf="uploadProgress > 0 && !uploadCompleted"
      mode="determinate"
      [value]="uploadProgress"></mat-progress-bar>

    <p *ngIf="uploadCompleted">Upload abgeschlossen!</p>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onClose()">Schließen</button>
</div>
